module.exports = __webpack_public_path__ + "img/img_tanchaungbg.01dc4c64.png";